import {
  IDownloadParticipantsItem,
  IDownloadParticipantsRenderedItem,
  IDownloadParticipantsStatuses,
} from 'entities/downloads/participants/types';
import { fromDateToHumanReadableText } from 'shared/helpers/fromDateToHumanReadableText';
import { IDownloadPrizesItem, IDownloadPrizesRenderedItem } from 'entities/downloads/prizes/types';

const mapStatusToText = (status: IDownloadParticipantsStatuses) => {
  switch (status) {
    case 'processing':
      return 'Обрабатывается';
    case 'success':
      return 'Успех';
    case 'error':
      return 'Ошибка';
  }
};

export const mapDownloadParticipantsToTableRenderType = (
  source: IDownloadParticipantsItem[],
): IDownloadParticipantsRenderedItem[] =>
  source.map((item) => ({
    ...item,
    status: mapStatusToText(item.status),
    downloaded: `${item.successful_lines} / ${item.total_lines}`,
    isShowDownloadButton: item.status === 'error' && item.err_file !== null,
    created_at: fromDateToHumanReadableText(item.created_at, true),
  }));

export const mapDownloadTableCodesToTableRenderType = (source: IDownloadPrizesItem[]): IDownloadPrizesRenderedItem[] =>
  source.map((item) => ({
    ...item,
    status: mapStatusToText(item.status),
    downloaded: `${item.successful_lines} / ${item.total_lines}`,
    isShowDownloadButton: item.status === 'error' && item.err_file !== null,
    created_at: fromDateToHumanReadableText(item.created_at, true),
  }));

export const mapDownloadBonusesToTableRenderType = mapDownloadParticipantsToTableRenderType;
export const mapDownloadPrizesToTableRenderType = mapDownloadTableCodesToTableRenderType;
